import {request, serviceUrl} from "@/utils/request";

//获取道闸进出监控
export function getParkingDetailsParentAccess() {
  return request({
    url: serviceUrl.iotboxService + '/iot/box/business/parking/gate/list'
  })
}

//道闸控制
export function ParkingGateControl( code, value) {
  return request({
    method: 'POST',
    url: serviceUrl.iotboxService + '/iot/box/business/parking/huize/control',
    params: { code: code, value: value}
  })
}

//可以通过道闸id，道闸code道闸数据
export function getParkingGate(note) {
  return request({
    method: 'POST',
    url: serviceUrl.iotboxService + '/iot/box/business/parking/gate/points',
    params: {code: note}
  })
}
